import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={14}
      height={12}
      viewBox="0 0 14 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M13.816 10.053L8.146.64c-.512-.852-1.78-.852-2.294 0L.184 10.053C-.335 10.915.304 12 1.332 12H12.67c1.026 0 1.665-1.083 1.146-1.947zM7 2.91a.85.85 0 01.86.887l-.214 3.54a.648.648 0 01-1.293 0l-.213-3.54A.85.85 0 017 2.91zm0 7.7a.9.9 0 01-.912-.887A.9.9 0 017 8.834a.9.9 0 01.912.888.9.9 0 01-.912.887z"
        fill="#FF4D4F"
      />
    </Svg>
  );
}

export default SvgComponent;
